export default __webpack_public_path__ + "static/media/bnr10.6d326b0d.jpg";